import { render, staticRenderFns } from "./SettingsTableKanbanSidebar.vue?vue&type=template&id=2931cfc2"
import script from "./SettingsTableKanbanSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsTableKanbanSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports